import FormBase from '@/components/forms/new/FormBase';
import ItemCodeItemCodeField from './formFields/ItemCodeItemCodeField';
import ItemCodeAccountCodeField from './formFields/ItemCodeAccountCodeField';
import ItemCodeTrackingName1Field from './formFields/ItemCodeTrackingName1Field';
import ItemCodeTrackingOption1Field from './formFields/ItemCodeTrackingOption1Field';
import BreadcrumbTrail from 'components/BreadcrumbTrail';

const ItemCodeMappingForm = ({
    mode,
    initialValues,
    isLoading,
    onBack,
    onSubmit,
    category,
    darkMode,
}) => {
    const header = `${mode === 'edit' ? 'Edit' : 'Add'} Item Code Mapping${category ? ` : ${category}` : ''}`;
    const breadCrumbTrail = [
        { label: 'Item Code Mappings', path: ['', { index: 0 }] },
        { label: header, path: '' },
    ];
    return (
        <>
            <BreadcrumbTrail
                breadCrumbTrail={breadCrumbTrail}
                handleBackButton={onBack}
            />
            <FormBase
                header={header}
                subTitleHeader={false}
                initialValues={initialValues}
                isLoading={isLoading}
                finalFormSubmit={onSubmit}
                onBack={onBack}
                customClick={true}>
                {({ errors, touched }) => {
                    const fields = [
                        <ItemCodeItemCodeField
                            key="itemCode"
                            darkMode={darkMode}
                            errors={errors}
                            touched={touched}
                        />,
                        <ItemCodeAccountCodeField
                            key="accountCode"
                            darkMode={darkMode}
                            errors={errors}
                            touched={touched}
                        />,
                        <ItemCodeTrackingName1Field
                            key="trackingName"
                            darkMode={darkMode}
                            errors={errors}
                            touched={touched}
                        />,
                        <ItemCodeTrackingOption1Field
                            key="trackingOption"
                            darkMode={darkMode}
                            errors={errors}
                            touched={touched}
                        />,
                    ];

                    return fields;
                }}
            </FormBase>
        </>
    );
};

export default ItemCodeMappingForm;
